module.exports = __webpack_public_path__ + "img/a3.5bd1cea9.png";